<template>
  <div id="app">
    <div class="header" v-if="isUserLoggedIn">
      <page-header />
    </div>
    <div class="main">
      <div class="menu" v-if="isUserLoggedIn">
        <Menu />
      </div>
      <router-view class="view" />
    </div>
    <link
      href="https://cdn.bootcss.com/font-awesome/4.7.0/css/font-awesome.min.css"
      rel="stylesheet"
    />
  </div>
</template>

<script>
import PageHeader from "./components/Header.vue";
import Menu from "./components/Menu.vue";
import { mapState } from "vuex";

export default {
  name: "App",
  metaInfo: {
    title: "DataMaestro",
  },
  components: { PageHeader, Menu },
  computed: {
    ...mapState(["isUserLoggedIn"]),
  },
};
</script>

<style>
h2 {
  font-size: 1.75rem !important;
}
.el-table .cell {
  word-break: normal !important;
}
span.el-table__empty-text {
  margin-top: 20px !important;
  line-height: 30px !important;
  width: 100% !important;
}
.main {
  display: flex !important;
}
.view {
  width: 100% !important;
}
.el-table {
  font-size: 14px !important;
  overflow: auto !important;
}
.el-tabs {
  max-height: 65vh !important;
  overflow: auto !important;
}
.el-tabs__item {
  font-weight: bold !important;
  color: #909399 !important;
  height: initial !important;
  line-height: inherit !important;
  padding: 12px 20px !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
  /* border-radius: 0px !important; */
}
select,
.el-table .body-row {
  cursor: pointer !important;
}
.main {
  z-index: 2 !important;
}
.header {
  position: relative !important;
  z-index: 1 !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
.el-form--label-top .el-form-item__label {
  margin-bottom: 0 !important;
  padding: 0 !important;
}
.el-loading-spinner .el-loading-text {
  color: #b3282d !important;
  font-size: 1.5rem !important;
}
.el-breadcrumb__inner {
  font-size: 16px !important;
  font-weight: normal !important;
  color: #606266 !important;
}
.el-breadcrumb__inner.is-link {
  font-size: 16px !important;
  font-weight: normal !important;
  color: #606266 !important;
  text-decoration: underline !important;
}
.form-control:disabled,
.custom-select:disabled {
  cursor: not-allowed !important;
}
.el-button--medium {
  padding: 5px 10px !important;
}
.el-button {
  font-weight: normal !important;
}
.el-menu {
  background-color: #b3282d !important;
  border: none !important;
}
.el-menu-item.is-active i {
  color: #b3282d !important;
}
.el-menu-item,
.el-submenu__title {
  font-size: 15px !important;
  color: white !important;
}
.el-menu-item.is-active,
.el-submenu__title.is-active {
  background-color: #f0f0f0 !important;
  color: #b3282d !important;
}
.el-menu-item.logout.is-active {
  background-color: #b3282d !important;
  color: white !important;
}
.el-menu-item:hover,
.el-submenu__title:hover,
.el-menu-item.logout.is-active:hover {
  background-color: #f0f0f0 !important;
}
.el-menu-item [class^="el-icon-"] {
  font-size: 18px !important;
}
.el-menu-item i,
.el-menu-item.logout.is-active i,
.el-submenu__icon-arrow,
.el-submenu [class^="el-icon-"] {
  color: white !important;
}
.el-tooltip.el-icon-info {
  z-index: 999 !important;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #b3282d !important;
}
</style>
